<template>
  <div class="w-100">
    <div class="container-fluid px-0">
      <div class="row align-items-center mb-2 mx-0">
        <div class="col-12 col-lg-6 text-left px-0">
          <div
            class="w-100  d-flex justify-content-between justify-content-lg-start"
          >
            <span class="rails-header-title">Saluran Feeling Feeling</span>
          </div>
        </div>
      </div>
      <div
        class="row mx-0 latest-tv-rails-content"
        id="saluranFastChannelTVHomepagev2"
      >
        <div class="w-100">
          <div
            class="owl-carousel owl-theme"
            id="salurantvfastchannelhomepagev2"
          >
            <div
              class="item"
              v-for="item_vod in tv_fast_channel_list"
              :key="item_vod.id"
              @mouseover="mouseOver"
              @mouseout="mouseOver"
            >
              <tv-card
                :image="item_vod.img_link"
                :title="item_vod.longTitle"
                :link="item_vod.redirect_url"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import tvCard from '../../../cards/v2/tvCard.vue';
import ChevronRight from '../../../../assets/rtmklik/svg/theme_chevron_right.svg';
import ChevronLeft from '../../../../assets/rtmklik/svg/theme_chevron_left.svg';
import axios from 'axios';
export default {
  data: function() {
    return {
      latest: [],
      tv_fast_channel_list: [],
      hover: false,
    };
  },
  components: { tvCard },
  created: function() {
    this.$store.dispatch('fetchRTMTVFastChannelList', { self: this });
  },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },
    goTo() {
      this.$router.push('/live/tv1');
    },
    filterTVFastChannelList() {
      var vm = this;
      vm.tv_fast_channel_list = this.$store.state.tv_fast_channel_list.data;
      var store = [];
      vm.tv_fast_channel_list.forEach((item) => {
        // var timecompare = this.formatTimestamp(item.dateAvailability);
        item['img_link'] = this.rtmImgLinkFiltering(item.data.images, '320x0');
        item['redirect_url'] = `/live/${this.lowerCaseAndRemoveSpace(
          item.longTitle
        )}`;
        store.push(item);
      });

      vm.tv_fast_channel_list = store;

      Vue.nextTick(
        function() {
          // Use a longer timeout if content is being loaded dynamically
          setTimeout(() => {
            vm.installOwlCarousel('#salurantvfastchannelhomepagev2');
          }, 300); // Longer timeout for dynamic content
        }.bind(vm)
      );
    },

    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 6,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveClass: true,
        navText: [`<img src=${ChevronLeft} />`, `<img src=${ChevronRight} />`],
        onInitialize: function(event) {
          if ($('.owl-carousel .item').length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 10,
            stagePadding: 0,
          },
          768: {
            items: 3,
            stagePadding: 0,
            loop: false,
            nav: false,
            margin: 14,
          },
          992: {
            items: 4,
            stagePadding: 0,
            loop: false,
            nav: true,
            margin: 6,
          },
          1280: {
            items: 6,
            stagePadding: 2,
            loop: false,
            nav: true,
            margin: 8,
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.section-padding {
  margin: 20px 8px 8px;
  height: auto !important;
  overflow: hidden;
}
</style>

<style>
.latest-tv-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

@media only screen and (min-width: 992px) {
  #saluranFastChannelTVHomepagev2 .owl-theme {
    height: auto;
  }
  #saluranFastChannelTVHomepagev2 .owl-item {
    z-index: 1;
  }
  #saluranFastChannelTVHomepagev2 .owl-item:hover {
    transition: 0.1s all ease-in-out;
    transform: scale(1.1);
    z-index: 2000;
  }
}

/* #saluranTVHomepagev2 .owl-prev span,
  .owl-next span {
    color: #dae12f !important;
  } */
#saluranFastChannelTVHomepagev2 .owl-theme .owl-nav.disabled {
  display: none !important;
}
#saluranFastChannelTVHomepagev2 .owl-nav {
  position: absolute;
  top: -51px;
  right: 2px;
  width: 80px;
  display: flex;
  justify-content: space-between;
}
#saluranFastChannelTVHomepagev2 .owl-prev {
}
#saluranFastChannelTVHomepagev2 .owl-prev img {
  width: 24px;
  height: 24px;
}

#saluranFastChannelTVHomepagev2 .owl-next {
}
#saluranFastChannelTVHomepagev2 .owl-next img {
  width: 24px;
  height: 24px;
}

button:focus {
  outline: unset !important;
}
</style>
